// // Login.jsx
// import React, { useState } from "react";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import { auth, db } from "../../firebase";
// import { useNavigate } from "react-router-dom";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );
//       const user = userCredential.user;

//       const userDoc = await getDoc(doc(db, "users", user.uid));
//       if (!userDoc.exists()) {
//         setError("User not found in database.");
//         return;
//       }

//       const userData = userDoc.data();
//       if (userData) {
//         console.log("User data:", userData);
//       }
//       if (!userData.isActive) {
//         setError("Account is deactivated.");
//         return;
//       }

//       if (userData.role === "admin") {
//         navigate("/admin");
//       } else if (userData.role === "agent") {
//         navigate("/agent-dashboard");
//       } else {
//         setError("Unknown role.");
//       }
//     } catch (err) {
//       setError("Login failed: " + err.message);
//     }
//   };

//   return (
//     <div>
//       <h2>Login</h2>
//       <input
//         placeholder="Email"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//       />
//       <input
//         placeholder="Password"
//         type="password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//       />
//       <button onClick={handleLogin}>Login</button>
//       {error && <p style={{ color: "red" }}>{error}</p>}
//     </div>
//   );
// };

// export default Login;

// ==========================================================================

// import React, { useState } from "react";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import { auth, db } from "../../firebase";
// import { useNavigate } from "react-router-dom";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );
//       const user = userCredential.user;

//       const userDoc = await getDoc(doc(db, "users", user.uid));
//       if (!userDoc.exists()) {
//         setError("User not found in database.");
//         return;
//       }

//       const userData = userDoc.data();
//       setTimeout(() => {}, 1000);

//       console.log("User data:", userData);

//       if (!userData.isActive) {
//         setError("Account is deactivated.");
//         return;
//       }

//       if (userData.role === "admin") {
//         navigate("/admin");
//       } else if (userData.role === "agent") {
//         localStorage.setItem("fscUser", userData.role);
//         navigate("/agent-dashboard");
//       } else {
//         setError("Unknown role.");
//       }
//     } catch (err) {
//       setError("Login failed: " + err.message);
//     }
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center vh-100">
//       <div
//         className="card p-4 shadow"
//         style={{ maxWidth: "400px", width: "100%" }}
//       >
//         <h2 className="text-center mb-4">Login</h2>
//         <div className="mb-3">
//           <input
//             className="form-control"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//         </div>
//         <div className="mb-3">
//           <input
//             className="form-control"
//             placeholder="Password"
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//         </div>
//         <button className="btn btn-primary w-100" onClick={handleLogin}>
//           Login
//         </button>
//         <div className="d-flex justify-content-end mt-3">
//           <h6>
//             Not Yet Registred{" "}
//             <a href="/register" className="w-100 mt-3">
//               Go to Register
//             </a>
//           </h6>
//         </div>

//         {error && <p className="text-danger mt-3 text-center">{error}</p>}
//       </div>
//     </div>
//   );
// };

// export default Login;
// ===================================================

// import React, { useState } from "react";
// import {
//   signInWithEmailAndPassword,
//   signInWithPopup,
//   signInWithPhoneNumber,
//   RecaptchaVerifier,
// } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import { auth, db, googleProvider } from "../../firebase";
// import { useNavigate } from "react-router-dom";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [phone, setPhone] = useState("");
//   const [otp, setOtp] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         email,
//         password
//       );
//       await handlePostLogin(userCredential.user);
//     } catch (err) {
//       setError("Login failed: " + err.message);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     try {
//       const result = await signInWithPopup(auth, googleProvider);
//       await handlePostLogin(result.user);
//     } catch (err) {
//       setError("Google login failed: " + err.message);
//     }
//   };

//   const handlePhoneLogin = async () => {
//     try {
//       window.recaptchaVerifier = new RecaptchaVerifier(
//         "recaptcha-container",
//         {},
//         auth
//       );
//       const appVerifier = window.recaptchaVerifier;
//       const confirmationResult = await signInWithPhoneNumber(
//         auth,
//         phone,
//         appVerifier
//       );
//       window.confirmationResult = confirmationResult;
//       setShowOtp(true);
//     } catch (err) {
//       setError("Phone login failed: " + err.message);
//     }
//   };

//   const verifyOtp = async () => {
//     try {
//       const result = await window.confirmationResult.confirm(otp);
//       await handlePostLogin(result.user);
//     } catch (err) {
//       setError("OTP verification failed: " + err.message);
//     }
//   };

//   const handlePostLogin = async (user) => {
//     const userDoc = await getDoc(doc(db, "users", user.uid));
//     if (!userDoc.exists()) {
//       setError("User not registered. Please register first.");
//       return;
//     }

//     const userData = userDoc.data();

//     if (!userData.isActive) {
//       setError("Account is deactivated.");
//       return;
//     }

//     localStorage.setItem("fscUser", userData.role);

//     if (userData.role === "admin") navigate("/admin");
//     else if (userData.role === "agent") navigate("/agent-dashboard");
//     else if (userData.role === "user") navigate("/user-dashboard");
//     else setError("Unknown role.");
//   };

//   return (
//     <div className="container d-flex justify-content-center align-items-center vh-100">
//       <div
//         className="card p-4 shadow"
//         style={{ maxWidth: "400px", width: "100%" }}
//       >
//         <h2 className="text-center mb-4">Login</h2>

//         <input
//           className="form-control mb-2"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//         <input
//           className="form-control mb-3"
//           placeholder="Password"
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//         <button className="btn btn-primary w-100 mb-2" onClick={handleLogin}>
//           Login with Email
//         </button>

//         <hr />
//         <button
//           className="btn btn-danger w-100 mb-2"
//           onClick={handleGoogleLogin}
//         >
//           Login with Google
//         </button>

//         <input
//           className="form-control mb-2"
//           placeholder="Phone Number"
//           value={phone}
//           onChange={(e) => setPhone(e.target.value)}
//         />
//         <div id="recaptcha-container" className="mb-2"></div>
//         <button
//           className="btn btn-success w-100 mb-2"
//           onClick={handlePhoneLogin}
//         >
//           Send OTP
//         </button>

//         {showOtp && (
//           <>
//             <input
//               className="form-control mb-2"
//               placeholder="Enter OTP"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//             />
//             <button className="btn btn-warning w-100 mb-2" onClick={verifyOtp}>
//               Verify OTP
//             </button>
//           </>
//         )}

//         {error && (
//           <div className="alert alert-danger text-center mt-3">
//             {error}
//             <div className="mt-2">
//               <a href="/register" className="btn btn-outline-primary btn-sm">
//                 Go to Register
//               </a>
//             </div>
//           </div>
//         )}

//         <div className="d-flex justify-content-end mt-3">
//           <h6>
//             Not Yet Registered?{" "}
//             <a href="/register" className="text-decoration-underline">
//               Go to Register
//             </a>
//           </h6>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithPhoneNumber,
  RecaptchaVerifier,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db, googleProvider } from "../../firebase";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [useMobileLogin, setUseMobileLogin] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      await handlePostLogin(userCredential.user);
    } catch (err) {
      setError("Login failed: " + err.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      await handlePostLogin(result.user);
    } catch (err) {
      setError("Google login failed: " + err.message);
    }
  };

  const handlePhoneLogin = async () => {
    try {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha-container",
        {},
        auth
      );
      const appVerifier = window.recaptchaVerifier;
      const confirmationResult = await signInWithPhoneNumber(
        auth,
        phone,
        appVerifier
      );
      window.confirmationResult = confirmationResult;
      setShowOtp(true);
    } catch (err) {
      setError("Phone login failed: " + err.message);
    }
  };

  const verifyOtp = async () => {
    try {
      const result = await window.confirmationResult.confirm(otp);
      await handlePostLogin(result.user);
    } catch (err) {
      setError("OTP verification failed: " + err.message);
    }
  };

  const handlePostLogin = async (user) => {
    const userDoc = await getDoc(doc(db, "users", user.uid));
    if (!userDoc.exists()) {
      setError("User not registered. Please register first.");
      return;
    }

    const userData = userDoc.data();

    if (!userData.isActive) {
      setError("Account is deactivated.");
      return;
    }

    localStorage.setItem("fscUser", userData.role);

    if (userData.role === "admin") navigate("/admin");
    else if (userData.role === "agent") navigate("/agent-dashboard");
    else if (userData.role === "user") navigate("/user-dashboard");
    else setError("Unknown role.");
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card p-4 shadow"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <h2 className="text-center mb-4">Login</h2>

        {!useMobileLogin ? (
          <>
            <input
              className="form-control mb-2"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="form-control mb-3"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              className="btn btn-primary w-100 mb-3"
              onClick={handleLogin}
            >
              Login with Email
            </button>
          </>
        ) : (
          <>
            <input
              className="form-control mb-2"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <div id="recaptcha-container" className="mb-2"></div>
            <button
              className="btn btn-success w-100 mb-2"
              onClick={handlePhoneLogin}
            >
              Send OTP
            </button>

            {showOtp && (
              <>
                <input
                  className="form-control mb-2"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button
                  className="btn btn-warning w-100 mb-2"
                  onClick={verifyOtp}
                >
                  Verify OTP
                </button>
              </>
            )}
          </>
        )}

        <div className="d-flex justify-content-between gap-2 mt-3">
          <button
            className="btn btn-outline-secondary w-100"
            onClick={() => setUseMobileLogin(!useMobileLogin)}
          >
            {useMobileLogin ? "Login with Email" : "Login with Mobile"}
          </button>

          <button
            className="btn btn-outline-danger w-100"
            onClick={handleGoogleLogin}
          >
            Login with Google
          </button>
        </div>

        {error && (
          <div className="alert alert-danger text-center mt-3">
            {error}
            <div className="mt-2">
              <a href="/register" className="btn btn-outline-primary btn-sm">
                Go to Register
              </a>
            </div>
          </div>
        )}

        <div className="text-center mt-3">
          Not Yet Registered?{" "}
          <a href="/register" className="text-decoration-underline">
            Go to Register
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
